import { render } from "./ProgressBar.vue?vue&type=template&id=645bb190&scoped=true"
import script from "./ProgressBar.vue?vue&type=script&lang=js"
export * from "./ProgressBar.vue?vue&type=script&lang=js"

import "./ProgressBar.vue?vue&type=style&index=0&id=645bb190&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-645bb190"]])

export default __exports__